export default {
    locationno: '事業所',
    inoutdate: '日付'
};
